import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import get from 'lodash/get';

import ContextAuthorCard from 'rebook/apps/catalog/components/ContextAuthorCard';
import ContextAuthorCardEmpty from 'rebook/apps/catalog/components/ContextAuthorCardEmpty';

import styles from './style.scss';


const getLetterBlock = (currentName, items, currentIndex) => {
  const firstLetter = currentName.charAt(0).toUpperCase();
  if (currentIndex === 0) {
    return (
      <li className={classNames(styles.initialLetter, 'jest-initial-letter-alphabetical-filtering')}>
        <span className={styles.letter}>
          {firstLetter}
        </span>
      </li>
    );
  }
  const lastFirstLetter = get(items, `[${currentIndex - 1}].last_name`, firstLetter).charAt(0).toUpperCase();
  if (firstLetter !== lastFirstLetter) {
    return (
      <li className={classNames(
        styles.initialLetter,
        styles.initialLetterInsideText,
        'jest-initial-letter-alphabetical-filtering'
      )}>
        <span className={styles.letter}>
          {firstLetter}
        </span>
      </li>
    );
  }
  else {
    return null;
  }
};

const AuthorList = ({ authors, orderBy }) => {
  return (
    <ul className={styles.authorList}>
      {authors.map((author, index) => {
        const lastName = get(author, 'last_name', null);
        return (
          <React.Fragment>
            {(lastName && orderBy === 'asc') && getLetterBlock(lastName, authors, index)}
            <li key={lastName ? `${lastName}_${index}` : index} className={styles.author}>
              {author ? <ContextAuthorCard author={author} /> : <ContextAuthorCardEmpty />}
            </li>
          </React.Fragment>
        );
      })}
    </ul>
  );
};

AuthorList.propTypes = {
  authors: PropTypes.array.isRequired,
};

export default AuthorList;
